import { TypeCodeTranslation } from '../../../business/models/shared.model';

export const enum DetailsInsuredPersonActionTypes {
  FETCH_INSURED_PERSON = '@@detailsInsuredPerson/FETCH_INSURED_PERSON',
  FETCH_INSURED_PERSON_SUCCESS = '@@detailsInsuredPerson/FETCH_INSURED_PERSON_SUCCESS',
  FETCH_INSURED_PERSON_FAIL = '@@detailsInsuredPerson/FETCH_INSURED_PERSON_FAIL',
  RESET_STATE = '@@detailsInsuredPerson/RESET_STATE',
  UPDATE_LANGUAGE_INSURED_PERSON = '@@detailsInsuredPerson/UPDATE_LANGUAGE_INSURED_PERSON',
  UPDATE_LANGUAGE_INSURED_PERSON_FAILED = '@@detailsInsuredPerson/UPDATE_LANGUAGE_INSURED_PERSON_FAILED',
  UPDATE_LANGUAGE_INSURED_PERSON_SUCCESS = '@@detailsInsuredPerson/UPDATE_LANGUAGE_INSURED_PERSON_SUCCESS',
}

export interface DetailsInsuredPersonState {
  readonly id: number;
  readonly firstName: string;
  readonly lastName: string;
  readonly companyName: string;
  readonly occupancy: string;
  readonly companyNumber: string;
  readonly clientType: string;
  readonly street: string;
  readonly buildingNumber: string;
  readonly busNumber: string;
  readonly zipCode: string;
  readonly city: string;
  readonly country: string;
  readonly accountNumber: string;
  readonly iban: string;
  readonly bic: string;
  readonly telephone: string;
  readonly telephoneWork: string;
  readonly mobile: string;
  readonly fax: string;
  readonly email: string;
  readonly language: string;
  readonly languageTC: string;
  readonly languageTypeList: TypeCodeTranslation[];
  readonly instructionId: number;
}
